var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filler-box",style:(_vm.style),attrs:{"id":"home-filler-box"}},[_vm._l((_vm.showIndexes),function(index){return [_c('i',{key:index,class:'fa fa-' + _vm.$t('home_promote_icon_' + index)}),_vm._v("\n    "+_vm._s(_vm.$t('home_promote_text_' + index) !== 'home_promote_text_' + index
        ? _vm.$t('home_promote_text_' + index)
        : '')+"\n  ")]}),(_vm.skipAutoHeight)?_c('div',{staticClass:"py-2 d-block"},[_vm._v("\n     \n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }